
(function() {
  if (window.location.pathname !== '/') return;
  
  var container = document.createElement('div');
  container.id = 'oven-scroll-widget';
  container.style.cssText = 'position:fixed;bottom:20px;right:20px;z-index:50;pointer-events:none;opacity:0;transition:opacity 0.5s ease;filter:drop-shadow(0 2px 6px rgba(0,0,0,0.3));';
  
  var inner = document.createElement('div');
  inner.style.cssText = 'width:56px;position:relative;';
  
  inner.innerHTML = '<svg viewBox="0 0 56 68" width="56" height="68" xmlns="http://www.w3.org/2000/svg">' +

    // Steam
    '<g id="oven-steam" opacity="0">' +
    '<path class="steam-p" d="M16,8 Q14,4 16,0" fill="none" stroke="#FDF6EE" stroke-width="1" stroke-linecap="round" opacity="0.5"/>' +
    '<path class="steam-p" d="M28,6 Q26,2 28,-2" fill="none" stroke="#FDF6EE" stroke-width="1.2" stroke-linecap="round" opacity="0.4"/>' +
    '<path class="steam-p" d="M40,8 Q38,4 40,0" fill="none" stroke="#FDF6EE" stroke-width="1" stroke-linecap="round" opacity="0.5"/>' +
    '</g>' +

    // Oven body
    '<rect x="2" y="10" width="52" height="54" rx="3" fill="#2d1b0e" stroke="#D4B896" stroke-width="1"/>' +

    // Control strip
    '<rect x="2" y="10" width="52" height="11" rx="3" fill="#3a2518"/>' +
    '<circle cx="14" cy="15.5" r="2.5" fill="#D4B896" stroke="#2d1b0e" stroke-width="0.5"/>' +
    '<circle cx="28" cy="15.5" r="2.5" fill="#D4B896" stroke="#2d1b0e" stroke-width="0.5"/>' +
    '<circle cx="42" cy="15.5" r="2.5" fill="#D4B896" stroke="#2d1b0e" stroke-width="0.5"/>' +

    // Oven door
    '<rect x="5" y="24" width="46" height="34" rx="2" fill="#1a0e06" stroke="#D4B896" stroke-width="0.8"/>' +

    // Window
    '<rect x="8" y="27" width="40" height="21" rx="1.5" fill="#0d0705" stroke="#6b5744" stroke-width="0.5"/>' +
    // Red/orange glow
    '<rect id="oven-glow" x="8" y="27" width="40" height="21" rx="1.5" fill="url(#ovenGlowGrad)" opacity="0"/>' +
    // Rack line
    '<line x1="10" y1="41" x2="46" y2="41" stroke="#6b5744" stroke-width="0.5" opacity="0.4"/>' +

    // Mandel bread loaf - rectangular/square shape on the rack
    '<g id="oven-loaf" opacity="0">' +
    '<rect id="loaf-body" x="16" y="33" width="24" height="8" rx="1.5" fill="#c4956a"/>' +
    // Slight rounded top rise
    '<path d="M16,35 Q16,32 19,31.5 L28,31 L37,31.5 Q40,32 40,35" fill="#d4a878" opacity="0.4"/>' +
    // Chocolate chips
    '<circle cx="20" cy="35" r="1.1" fill="#2d1b0e"/>' +
    '<circle cx="25" cy="33.5" r="1" fill="#3a2518"/>' +
    '<circle cx="30" cy="35.5" r="1.1" fill="#2d1b0e"/>' +
    '<circle cx="35" cy="34" r="1" fill="#3a2518"/>' +
    '<circle cx="23" cy="37.5" r="0.9" fill="#2d1b0e"/>' +
    '<circle cx="32" cy="38" r="0.9" fill="#2d1b0e"/>' +
    '<circle cx="37" cy="37" r="0.8" fill="#3a2518"/>' +
    '</g>' +

    // Handle
    '<rect x="18" y="52" width="20" height="3" rx="1.5" fill="#D4B896"/>' +

    // Progress bar built into the oven bottom edge
    '<rect x="5" y="60" width="46" height="2" rx="1" fill="#1a0e06"/>' +
    '<rect id="oven-progress" x="5" y="60" width="0" height="2" rx="1" fill="#D4B896"/>' +

    '<defs>' +
    '<radialGradient id="ovenGlowGrad" cx="50%" cy="60%" r="60%">' +
    '<stop id="glow-inner" offset="0%" stop-color="#ff3300" stop-opacity="0.7"/>' +
    '<stop id="glow-mid" offset="50%" stop-color="#ff5500" stop-opacity="0.4"/>' +
    '<stop id="glow-outer" offset="100%" stop-color="#ff2200" stop-opacity="0.08"/>' +
    '</radialGradient>' +
    '</defs>' +
    '</svg>';
  
  container.appendChild(inner);
  document.body.appendChild(container);
  
  var style = document.createElement('style');
  style.textContent = '@keyframes steamRise{0%{transform:translateY(0);opacity:0.5}100%{transform:translateY(-8px);opacity:0}}.steam-p{animation:steamRise 2s ease-out infinite}.steam-p:nth-child(2){animation-delay:0.5s}.steam-p:nth-child(3){animation-delay:1s}';
  document.head.appendChild(style);
  
  var glow = document.getElementById('oven-glow');
  var steam = document.getElementById('oven-steam');
  var progress = document.getElementById('oven-progress');
  var loaf = document.getElementById('oven-loaf');
  var loafBody = document.getElementById('loaf-body');
  
  function lerp(a, b, t) {
    var ah=parseInt(a.slice(1),16),bh=parseInt(b.slice(1),16);
    var ar=ah>>16,ag=(ah>>8)&0xff,ab=ah&0xff;
    var br=bh>>16,bg=(bh>>8)&0xff,bb=bh&0xff;
    return '#'+((Math.round(ar+(br-ar)*t)<<16)|(Math.round(ag+(bg-ag)*t)<<8)|Math.round(ab+(bb-ab)*t)).toString(16).padStart(6,'0');
  }
  
  var doughStops=[{p:0,c:'#e8d5b8'},{p:0.3,c:'#d4bf9a'},{p:0.6,c:'#c4956a'},{p:0.85,c:'#b8844c'},{p:1,c:'#a87040'}];
  function loafColor(pct){for(var i=1;i<doughStops.length;i++){if(pct<=doughStops[i].p){var t=(pct-doughStops[i-1].p)/(doughStops[i].p-doughStops[i-1].p);return lerp(doughStops[i-1].c,doughStops[i].c,t);}}return doughStops[doughStops.length-1].c;}
  
  window.addEventListener('scroll', function() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var pct = Math.min(scrollTop / docHeight, 1);
    
    container.style.opacity = scrollTop > 150 ? '1' : '0';
    if (glow) glow.setAttribute('opacity', String(pct * 0.95));
    var gi = document.getElementById('glow-inner');
    var gm = document.getElementById('glow-mid');
    var go = document.getElementById('glow-outer');
    if (gi) { gi.setAttribute('stop-opacity', String(0.3 + pct * 0.7)); }
    if (gm) { gm.setAttribute('stop-opacity', String(0.1 + pct * 0.5)); }
    if (go) { go.setAttribute('stop-opacity', String(pct * 0.25)); }
    if (loaf) loaf.setAttribute('opacity', String(pct > 0.1 ? Math.min((pct - 0.1) * 2, 1) : 0));
    if (loafBody) loafBody.setAttribute('fill', loafColor(pct));
    if (steam) steam.setAttribute('opacity', String(pct > 0.3 ? Math.min((pct - 0.3) * 1.5, 1) : 0));
    if (progress) progress.setAttribute('width', String(Math.round(pct * 46)));
  });
})();
